import { useSelector } from 'react-redux';
import oddsTransformer from '../oddsTransformer';
import { isHandicap90Specifier } from '../utils';

const _oddsTransformer = oddsTransformer();

const useOddTransformer = () => {
  const customerCustomOddsMultiplier = useSelector(
    (state) => state.auth.userLimits?.customOddsMultiplier
  );

  const customOddsMultiplier = customerCustomOddsMultiplier;
  const transform = (
    isLive,
    isOutRights,
    marketNumericId,
    sportEventStartTime,
    odds,
    marketStringId
  ) => {
    // For Maradona Handicap (14-m-S:0:9 or 14-m-S:9:0), force multiplier = 1.0
    const isMaradonaHandicap = isHandicap90Specifier(marketStringId);
    const effectiveMultiplier = isMaradonaHandicap ? 1.0 : customOddsMultiplier ?? 1.0;
    const customOdds = effectiveMultiplier * odds;

    return _oddsTransformer.transform(
      new Date(),
      isLive,
      isOutRights,
      marketNumericId,
      sportEventStartTime,
      customOdds
    );
  };

  const transformWithDisplayFormatted = (
    isLive,
    isOutRights,
    marketNumericId,
    sportEventStartTime,
    odds,
    marketStringId
  ) => {
    const transformed = transform(
      isLive,
      isOutRights,
      marketNumericId,
      sportEventStartTime,
      odds,
      marketStringId
    );

    if (transformed >= 100) {
      return transformed.toFixed(0);
    }

    return transformed > 10 ? transformed.toFixed(1) : transformed.toFixed(2);
  };

  return { transform, transformWithDisplayFormatted };
};

export default useOddTransformer;
